import type { FaireBrandEntity } from "../../entity_types/brand";

export const noshinku: FaireBrandEntity = {
  token: "noshinku",
  type: "brand",
  name: "Noshinku",
  minimumOrderDollars: 100,
  rating: 4.8,
  reviewCount: 124,
  isTopShop: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
